import { SubSink } from 'subsink';
import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingType } from '@monorepo/ui';
import { StateType } from '@monorepo/ui';
import { debounceTime, withLatestFrom } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

import { LocationDetailsService } from './../../services/location-details.service';

import { SeoService } from '../../../shared/services/seo-service/seo.service';
import { OpenGraphConfig, ScreenListing } from '../../../shared/models';
import { AngularFireAuth } from '@angular/fire/auth';
import { AlgoliaAnalyticsService } from '../../../shared/services/algolia-analytics/algolia-analytics.service';

enum PageState {
  LOADING,
  LOADED,
  NO_LISTING,
}
@Component({
  selector: 'signgaze-location-detail-container',
  templateUrl: './location-detail-container.component.html',
  styleUrls: ['./location-detail-container.component.scss'],
})
export class LocationDetailContainerComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  @ViewChild('addToCart', { static: false })
  addToCart: ElementRef;

  screenListingId: string;
  screenListing: ScreenListing;
  isUserSignedIn = false;
  StateTypeEnum: any = StateType;
  pageStateEnum: any = PageState;
  pageState: PageState = this.pageStateEnum.LOADING;
  LoadingTypeEnum: any = LoadingType;

  constructor(
    private activatedRoute: ActivatedRoute,
    private locationDetailService: LocationDetailsService,
    private seo: SeoService,
    private afAuth: AngularFireAuth,
    private algoliaAnalyticsService: AlgoliaAnalyticsService
  ) {}

  ngOnInit() {
    this.getUserStateAndListing();
    this.handleLightFixedMenu();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private getUserStateAndListing(): void {
    this.subs.sink = this.afAuth.authState
      .pipe(withLatestFrom(this.activatedRoute.params))
      .subscribe({
        next: (source: any[]) => {
          if (source[0]) {
            this.isUserSignedIn = true;
          } else {
            this.isUserSignedIn = false;
          }
          if (source[1].id) {
            this.screenListingId = source[1].id;
            this.getListing();
            this.algoliaAnalyticsService.sendUserInsights(
              'View Listing',
              source[0].uid || 'anon',
              this.screenListingId
            );
          }
        },
      });
  }

  private getListing(): void {
    this.subs.sink = this.locationDetailService
      .getscreenListing(this.screenListingId)
      .subscribe({
        next: (listing: any): void => {
          this.pageState = PageState.LOADED;
          this.screenListing = listing;
          this.setOpenGraphTags();
        },
      });
  }

  private handleLightFixedMenu(): void {
    fromEvent(document, 'scroll')
      .pipe(debounceTime(20))
      .subscribe({
        next: () => {
          if (
            document.body.scrollTop > 300 ||
            document.documentElement.scrollTop > 300
          ) {
            // this.addToCart?.nativeElement.classList.add('bottomscrolled');
          } else {
            // this.addToCart?.nativeElement.classList.remove('bottomscrolled');
          }
        },
      });
  }

  private setOpenGraphTags(): void {
    const screenListingUrl = `listings/${this.screenListingId}`;
    const openGraphConfig: OpenGraphConfig = new OpenGraphConfig(
      this.screenListing.screenName,
      this.screenListing.screenDescription,
      this.screenListing.screenImages[0].url,
      screenListingUrl
    );
    this.seo.generateTags(openGraphConfig);
  }
}
